export default function BillingCircle() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="24" height="24" rx="12" fill="#18181B" />
      <path
        d="M8 7.5H16M8 10.5H16M8 13.5H13M8 16.5H11M9.5 6.5H14.5L17.5 9.5V17.5C17.5 17.7761 17.2761 18 17 18H7C6.72386 18 6.5 17.7761 6.5 17.5V7C6.5 6.72386 6.72386 6.5 7 6.5H9.5Z"
        stroke="#A1A1AA"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
